import { Survey } from './general/models';
import { get, patch } from './client';
import { buildPath, toJson } from './utils';
import { SURVEY_BY_EMAIL_PATH, USER_PATH } from './constants';
import { IdType } from './types';

const SURVEYS_EVENT = 'surveys-event';

export const getSurveyByEmail = (options: any): Promise<Survey> =>
  get(buildPath(SURVEY_BY_EMAIL_PATH), options).then(toJson);

export const updateSurveyByEmail = (options: any): Promise<Survey> =>
  patch(buildPath(SURVEY_BY_EMAIL_PATH), options).then(toJson);

export const getSurveys = (userId: IdType, options: any): Promise<Survey[]> =>
  get(buildPath(USER_PATH, userId, SURVEYS_EVENT), options).then(toJson);

export const updateSurvey = (id: IdType, userId: IdType, options: any): Promise<Survey[]> =>
  patch(buildPath(USER_PATH, userId, SURVEYS_EVENT, id), options).then(toJson);
